import React, { useEffect } from "react"

import { Tooltip } from "@cirrus/ui-kit-ts/src/components/atoms/Tooltip"

import { LeftProgressCell, PercentageProgressCell } from "../components/ProgressCell"
import { SearchField } from "../components/SearchField"
import { ITableColumn, ProgressColumnType } from "../components/TableColumns"
import { useTableContext } from "../provider"

function getRenderHeader(column: ITableColumn) {
  const { search, tooltip, headerName, field } = column

  return () => {
    if (search) return <SearchField />

    if (tooltip)
      return (
        <Tooltip title={tooltip} placement={"bottom"}>
          {headerName || field}
        </Tooltip>
      )

    return <div>{headerName || field}</div>
  }
}

const getTargetCell = (props) => {
  const {row, value} = props
  const style = {
    fontWeight: row.left === 0 ? "bold" : "normal",
    color: row.left === 0 ? "#339F7A" : "inherit"
  }

  return <span style={style}>{value}</span>
}

const getProgressCell = ({ row }) => {
  // TODO: Fix hook usage outside of react components
  const ctx = useTableContext()

  return ctx.props.progressType === ProgressColumnType.PERCENTAGE
    ? <PercentageProgressCell percentage={row.percentage} />
    : <LeftProgressCell maxTotal={ctx.props.totalProgress?.maxTotal || 0} left={row.left} total={row.total} />
}

export const useColumnDefinitions = () => {

  const ctx = useTableContext()

  const { customizableColumns, order } = ctx.columns.state

  useEffect(() => {

    const definitions = customizableColumns
      .map((item) => {

        const column: ITableColumn = {
          ...item,
          index: order[item.field] + 1,
          headerClassName: item.headerClassName ?? "",
        }

        if (!column.renderHeader) column.renderHeader = getRenderHeader(item)

        if (column.field === "icon" || column.field === "custom") column.renderHeader = () => <div></div>

        if (column.isProgress) column.renderCell = getProgressCell

        if (column.isTarget && ctx.props.progressType === ProgressColumnType.COUNT) column.renderCell = getTargetCell

        return column
      })
    .sort((a, b) => (a.index ?? 0) - (b.index ?? 0))

    ctx.columns.api.setDefinitions(definitions)

  }, [customizableColumns, order])

  return {}
}
